export const cookies = () => {

    const cookies = document.querySelector('.js-cookies');
    const cookiesBtn = document.querySelector('.js-cookies-btn');

    if (!cookies || !cookiesBtn) return;

    const STORAGE_KEY = 'cookiesAccepted';

    if (localStorage.getItem(STORAGE_KEY) === 'true') {
        cookies.classList.remove('cookies_show');
        return;
    } else {
        cookies.classList.add('cookies_show');
    }

    cookiesBtn.addEventListener('click', () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        cookies.classList.remove('cookies_show');
    });
    
}